import naja from "naja";
import sortable from "html5sortable/src/html5sortable";
import typeaheadLoader from "../../components/typeahead";

let _html
export default function(html) {
	_html = html
	sortNavigation(html)
}


function itemCallback(e) {
	e.preventDefault();

	const icon = e.currentTarget.querySelector('i.fas')
	const expand = icon.classList.contains('fa-chevron-down')

	if (expand) {
		icon.classList.remove('fa-chevron-down')
		icon.classList.add('fa-chevron-up')
	} else {
		icon.classList.remove('fa-chevron-up')
		icon.classList.add('fa-chevron-down')
	}

	const item = e.currentTarget.closest('.item')
	const level = parseInt(item.dataset.level) + 1
	const parentKey = e.currentTarget.dataset.parentKey

	let current = item.nextElementSibling
	while (current) {
		if (expand) {
			if (current.classList.contains('d-none') && parseInt(current.dataset.level) === level && current.dataset.parentKey === parentKey) {
				current.classList.remove('d-none')
			}
		} else {
			if (!current.classList.contains('d-none') && parseInt(current.dataset.level) === level && current.dataset.parentKey === parentKey) {
				current.classList.add('d-none')
			}
		}

		current = current.nextElementSibling
	}
}


function typeaheadCallback(e) {
	const input = e.currentTarget.closest('.typeahead').querySelector('input[type=text]')
	const parent = input.closest('.item.add-item')
	const url = input.dataset.createItem
	const data = {
		dataSourceId: e.currentTarget.value,
		parentKey: parent.dataset.parentKey,
		level: parent.dataset.level
	}

	naja.makeRequest('GET', url, data, {history: false}).then((payload) => {
		parent.insertAdjacentHTML('beforebegin', payload.html)

		typeaheadLoader(parent.previousElementSibling)
		sortNavigation(_html)

		input.value = ''
		input.focus()

	}).catch((err) => {
		alert(err)
	})
}


function btnCallback(e) {
	e.preventDefault()

	e.currentTarget.classList.add('d-none')
	const typeahead = e.currentTarget.nextElementSibling
	const input = typeahead.querySelector('input[type=text]')
	input.classList.remove('d-none')
	input.focus()

	const target = typeahead.querySelector(typeahead.dataset.target)
	target.removeEventListener('fill', typeaheadCallback)
	target.addEventListener('fill', typeaheadCallback)
}


function removeBtnCallback(e) {
	e.preventDefault()

	const parent = e.currentTarget.dataset.parentKey

	let i = 0
	const queue = [parent]
	while (i < queue.length) {
		const rootKey = queue[i]
		const query = rootKey === '' ? '.item[data-parent-key="' + rootKey + '"]' : '.item[data-key="' + rootKey + '"]'
		_html.querySelectorAll(query).forEach((root) => {
			const key = root.dataset.key
			Array.from(_html.querySelectorAll('.items-sortable .item[data-parent-key="' + key + '"]')).forEach((child) => {
				if (typeof child.dataset.key !== "undefined") {
					queue.push(child.dataset.key)
				}

				child.remove()
			})
		})
		i++
	}

	_html.querySelector('.item[data-key="' + parent + '"]')?.remove()
}


function sortNavigation(html) {
	let i = 0
	const queue = ['']
	while (i < queue.length) {
		const rootKey = queue[i]
		const query = rootKey === '' ? '.item[data-parent-key="' + rootKey + '"]' : '.item[data-key="' + rootKey + '"]'
		html.querySelectorAll(query).forEach((root) => {
			const key = root.dataset.key
			Array.from(html.querySelectorAll('.items-sortable .item[data-parent-key="' + key + '"]')).reverse().forEach((child) => {
				if (typeof child.dataset.key !== "undefined") {
					queue.push(child.dataset.key)
				}
				root.after(child)
			})
		})
		i++
	}

	const list = []
	html.querySelectorAll('.items-sortable .item-nav').forEach((el) => {
		const parent = el.dataset.parentKey
		if (typeof list[parent] === "undefined") {
			list[parent] = []
		}

		el.querySelector('input[name*=position]').value = list[parent].length
		el.querySelector('input[name*=parent]').value = parent
		list[parent].push(el.dataset.key)
	})

	html.querySelectorAll('form#frm-navigationForm .item').forEach((item) => {
		item.querySelector('.item-children a')?.removeEventListener('click', itemCallback)
		item.querySelector('.item-children a')?.addEventListener('click', itemCallback)

		item.querySelector('button.remove-item')?.removeEventListener('click', removeBtnCallback)
		item.querySelector('button.remove-item')?.addEventListener('click', removeBtnCallback)
	})

	html.querySelectorAll('form#frm-navigationForm .item.add-item > button').forEach((btn) => {
		btn.removeEventListener('click', btnCallback)
		btn.addEventListener('click', btnCallback)
	})

	sortable('.items-sortable', {
		forcePlaceholderSize: true,
		placeholder: '<div class="sortable-placeholder">' + html.querySelector('.items-sortable').dataset.placeholder + '</div>',
		handle: '.item-move'
	})[0].addEventListener('sortupdate', (e) => {
		const item = e.detail.item

		let sibling = item.previousElementSibling
		if (sibling.classList.contains('add-item')) {
			sibling = html.querySelector('.items-sortable .item[data-key="' + sibling.dataset.parentKey + '"]')
		} else {
			while (sibling) {
				if (sibling.classList.contains('item-nav') && !sibling.classList.contains('d-none')) {
					break
				}

				sibling = sibling.previousElementSibling
			}
		}

		const level = parseInt(sibling.dataset.level)

		item.dataset.parentKey = sibling.dataset.parentKey
		item.dataset.level = level.toString()
		item.style.marginLeft = level * 50 + 'px'

		sortNavigation(html)
	})
}
